import store from 'services/redux/store'
import _ from 'lodash'
import { bookingOptions } from "utils/constants/booking-constants";
import { cartConstants } from 'services/redux/cart/constants'
import { ADD_CART, REMOVE_CART, SET_CART } from "services/redux/action-types";
import { employeeConstants } from "utils/constants/employee-constants";
import { resetCart, resetCartTimeslots } from 'services/redux/cart/actions'

const HelperCart = {
	
	resetAll: () => {
		store.dispatch( resetCartTimeslots() );
		store.dispatch( resetCart() );
	},
	
	resetCart: () => {
		store.dispatch( resetCart() );
	},
	
	resetCartTimeslots: () => {
		store.dispatch( resetCartTimeslots() );
	},

	cartBookSetForOption: (forOption ) => {
		store.dispatch({
			type: SET_CART,
			key: cartConstants.BOOK_FOR_OPTION,
			payload: forOption
		});
	},
	
	getCoworkerCount: () => {
		const _bookingExternalPersons = store.getState().cart[ cartConstants.BOOKING_EXTERNAL_PERSONS ];
		const _cartBookingCoworkers = store.getState().cart[ cartConstants.BOOKING_COWORKERS ];
		
		return _.size( _bookingExternalPersons ) + _.size( _cartBookingCoworkers );
	},
	
	bookingForMyself: ( _bookForOption ) => {
		if( _bookForOption === undefined ){
			_bookForOption = store.getState().cart[ cartConstants.BOOK_FOR_OPTION ];
		}
		
		const items = [
			bookingOptions.MYSELF,
			bookingOptions.MYSELF_AND_COWORKERS
		];
		
		return _.includes( items, _bookForOption )
	},
	
	bookingForMultiple: () => {
		const _bookForOption = store.getState().cart[ cartConstants.BOOK_FOR_OPTION ];
		
		const items = [
			bookingOptions.MYSELF_AND_COWORKERS,
			bookingOptions.COWORKERS
		];
		
		return _.includes( items, _bookForOption )
	},
	
	bookingForOthers: () => {
		const _bookForOption = store.getState().cart[ cartConstants.BOOK_FOR_OPTION ];
		
		const items = [
			bookingOptions.COWORKERS,
		];
		
		return _.includes( items, _bookForOption )
	},

	isEmployeeSelected: ( guid ) => {
		return  _.has( store.getState().cart[ cartConstants.BOOKING_COWORKERS ], guid );
	},
	
	toggleEmployee: ( employee ) => {
		if( HelperCart.isEmployeeSelected( employee.guid ) ){
			store.dispatch({
				type: REMOVE_CART,
				key: cartConstants.BOOKING_COWORKERS,
				payload: employee.guid
			});
		}else{
			store.dispatch({
				type: ADD_CART,
				key: cartConstants.BOOKING_COWORKERS,
				payload: { [ employee.guid ] : employee }
			});
		}
	},
	
	isExternalContactSelected: ( external_contact ) => {
		return  _.has( store.getState().cart[ cartConstants.BOOKING_EXTERNAL_PERSONS ], external_contact.guid );
	},
	
	toggleExternalContact: ( external_contact ) => {
		if( HelperCart.isExternalContactSelected( external_contact ) ){
			store.dispatch({
				type: REMOVE_CART,
				key: cartConstants.BOOKING_EXTERNAL_PERSONS,
				payload: external_contact.guid
			});
			return
		}
		
		const payload = {
			[ external_contact.guid ]: {
				guid: external_contact.guid,
				name: external_contact.name,
				email: external_contact.email,
				photo_url: external_contact.photo_url,
				manual: _.get( external_contact, 'manual', false ),
				kind: employeeConstants.KIND_EXTERNAL
			}
		};
		
		store.dispatch({
			type: ADD_CART,
			key: cartConstants.BOOKING_EXTERNAL_PERSONS,
			payload: payload
		});
		
		/*
			addBookingExternalUser: (payload) => dispatch({
			type: ADD_CART,
			key: cartConstants.BOOKING_EXTERNAL_PERSONS,
			payload: payload
		}),
		removeBookingExternalUser: (payload) => dispatch({
			type: REMOVE_CART,
			key: cartConstants.BOOKING_EXTERNAL_PERSONS,
			payload: payload
		})
		*/
	}
}

export default HelperCart
